import { minBreakpoints, primaryRegularFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, smallElevation } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const partner = css`
  align-items: center;
  grid-row-gap: ${spacing.md}px;
  background-color: color-mix(in srgb, var(${themeVariables.colors.content.link}) 5%, white);
  padding-left: ${spacing.md}px;
  padding-right: ${spacing.md}px;
`;

export const imageWrapper = css`
  grid-column: span 4;
  display: grid;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -${spacing.md}px;
  padding: ${spacing.base}px;
  aspect-ratio: 1 / 1;
  background-color: var(${themeVariables.colors.surface.default});
  border-radius: ${spacing.sm}px;
  ${smallElevation};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: span 3;
    `,
  )}
`;

export const image = css`
  max-width: 100%;
`;

export const content = css`
  grid-column: span 8;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 4;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: span 6;
    `,
  )}
`;

export const heading = css`
  ${responsiveText.HEADING.XS};
  margin: 0 0 ${spacing.xs}px 0;
  ${primaryRegularFont};
  > a {
    text-decoration: none;
    color: var(${themeVariables.colors.content.interactive});
  }
`;

export const infoItems = css`
  margin: 0;
  padding: 0;
  list-style-type: none;
  color: var(${themeVariables.colors.content.default});
  ${responsiveText.BODY.SM};

  li {
    margin: 0 0 ${spacing.xs}px 0;

    span {
      display: inline-block;
      margin-right: 5px;
      vertical-align: text-bottom;
    }
  }

  a {
    display: flex;
    align-items: center;
    font-weight: bold;
    text-decoration: none;
    color: var(${themeVariables.colors.content.link});
  }
`;

export const buttons = css`
  margin-bottom: ${spacing.sm}px;
  grid-column: span 12;
  display: flex;
  justify-content: center;
  gap: ${spacing.xl}px;
  align-items: center;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 4;
      flex-direction: column;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: span 3;
    `,
  )}
`;
